import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import Loader from "../Common/Loader";
import CommonService from "../../services/common.service";
import DashboardService from "../../services/dashboard.service";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";

const RoundPage = () => {
  useAutoAddQueryString();
  const [roundData, setRoundData] = useState([]);
  const [lockoutList, setLockoutList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCurrent, setIsCurrent] = useState("");
  const [nextTradeWindowDetails, setNextTradeWindowDetails] = useState({});
  const [currentTradeWindowDetails, setCurrentTradeWindowDetails] = useState(
    {}
  );
  const [nextRoundDetails, setNextRoundDetails] = useState({});
  const [currentRoundDetails, setCurrentRoundDetails] = useState({});

  useEffect(() => {
    fetchRoundData();
  }, []);

  const fetchRoundData = () => {
    CommonService.getCurrentRoundDetail().then((res) => {
      if (res.status === 200) {
        setCurrentRoundDetails(res.data);
        setNextRoundDetails(res.nextRoundDetails);
        setIsCurrent(res.isCurrent);
      }
    });
    CommonService.getUserDetail().then((res) => {
      if (res.success) {
        setRoundData(res.data?.get_round);
        setIsLoading(false);
      }
    });
    CommonService.getTradingWindows().then((res) => {
      setCurrentTradeWindowDetails(res.currentTradeWindowDetails);
      setNextTradeWindowDetails(res.nextTradeWindowDetails);
    });
  };
  const fetchTradeData = () => {
    DashboardService.getTradingListing().then((res) => {
      setLockoutList(res.data);
      setIsCurrent(res.isCurrent);
      setIsLoading(false);
    });
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Rounds & Trade Windows</h2>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link active`}
                  id="overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#overall"
                  type="button"
                  role="tab"
                  aria-controls="overall"
                  aria-selected="true"
                >
                  Rounds
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="round-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#round"
                  type="button"
                  role="tab"
                  aria-controls="round"
                  aria-selected="true"
                  onClick={fetchTradeData}
                >
                  Trades Window
                </button>
              </li>
            </ul>
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="overall"
                role="tabpanel"
                aria-labelledby="overall-tab"
              >
                <div className="customscroll">
                  <div class="datefilter">
                    <ul className="currentround">
                      {currentRoundDetails && (
                        <li>
                          <div class="form-group startdate">
                            <label>
                              {" "}
                              {isCurrent === true ? " Current " : "Previous"}
                            </label>
                            <span>
                              R{currentRoundDetails?.round} (
                              {moment(currentRoundDetails?.start_date).format(
                                "MMM D, h:mma"
                              )}{" "}
                              -{" "}
                              {moment(currentRoundDetails?.end_date).format(
                                "MMM D, h:mma"
                              )}
                              )
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div class="form-group enddate">
                          {nextRoundDetails && (
                            <>
                              <label>Next</label>
                              <span>
                                {" "}
                                R{nextRoundDetails?.round} (
                                {moment(nextRoundDetails?.start_date).format(
                                  "MMM D, h:mma"
                                )}{" "}
                                -{" "}
                                {moment(nextRoundDetails?.end_date).format(
                                  "MMM D, h:mma"
                                )}
                                )
                              </span>
                            </>
                          )}

                          {!nextRoundDetails && (
                            <>
                              <label> Next</label> <span> Completed</span>
                            </>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <table className="table ranktable rankNewTableClass">
                    <thead>
                      <tr>
                        <th>Round</th>
                        <th>Start Day</th>
                        <th>End Day</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roundData.length > 0 &&
                        roundData.map((item, key) => (
                          <tr key={key}>
                            <td>{item.round}</td>
                            <td>
                              {moment(item.start_date).format("D.MM.YYYY")}
                            </td>
                            <td>{moment(item.end_date).format("D.MM.YYYY")}</td>
                            <td>{moment(item.start_date).format("h:mm A")}</td>
                            <td>{moment(item.end_date).format("h:mm A")}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="round"
                role="tabpanel"
                aria-labelledby="round-tab"
              >
                <div className="customscroll">
                  <div className="datefilter">
                    <ul className="currentround">
                      {currentTradeWindowDetails && (
                        <li>
                          <div class="form-group startdate">
                            <label>
                              {" "}
                              {isCurrent === true ? " Current " : "Previous"}
                            </label>
                            <span>
                              TW{currentTradeWindowDetails?.round} (
                              {moment(
                                currentTradeWindowDetails.trade_start
                              ).format("MMM D, h:mma")}{" "}
                              -{" "}
                              {moment(
                                currentTradeWindowDetails.trade_close
                              ).format("MMM D, h:mma")}
                              )
                            </span>
                          </div>
                        </li>
                      )}
                      <li>
                        <div class="form-group enddate">
                          {nextTradeWindowDetails && (
                            <>
                              <label>Next</label>
                              <span>
                                TW{nextTradeWindowDetails?.round} (
                                {moment(
                                  nextTradeWindowDetails.trade_start
                                ).format("MMM D, h:mma")}{" "}
                                -{" "}
                                {moment(
                                  nextTradeWindowDetails.trade_close
                                ).format("MMM D, h:mma")}
                                )
                              </span>
                            </>
                          )}

                          {!nextTradeWindowDetails && (
                            <>
                              <label> Next</label> <span> Completed</span>
                            </>
                          )}
                        </div>
                      </li>
                    </ul>
                  </div>
                  <table className="table ranktable rankNewTableClass">
                    <thead>
                      <tr>
                        <th>Trade Window</th>
                        <th>Start Day</th>
                        <th>End Day</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {lockoutList &&
                        lockoutList.map((item, key) => (
                          <tr key={key}>
                            <td>{++key}</td>
                            <td>
                              {moment(item.trade_start).format("D.MM.YYYY")}
                            </td>
                            <td>
                              {moment(item.trade_close).format("D.MM.YYYY")}
                            </td>
                            <td>{moment(item.trade_start).format("h:mm A")}</td>
                            <td>{moment(item.trade_close).format("h:mm A")}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RoundPage;
